export default __webpack_public_path__ + "static/media/fontainebleau10.e51c35d9.jpg";